module.exports = __webpack_public_path__ + "trivia_onboarding-444d51c1a61511fd637990e2e554cbbe.png";